<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer localinfo">
      <div class="innerColumn">
      <h1 class="contentTitle">{{locale.localinfo}}</h1>
      <LocalInfoList
        :locale="locale"
        :list="list" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <LocalInfoFilter
          :locale="locale" />
      </div></div>
    </section>
    <div id="setContent">
      <LocalInfoSetting
        :locale="locale" />
    </div>
  </div>
</template>

<script>
import LocalInfoFilter from '@/components/LocalInfo/Filter.vue'
import LocalInfoList from '@/components/LocalInfo/List.vue'
import LocalInfoSetting from '@/components/LocalInfo/Setting.vue'

export default {
  name: 'LocalInfo',
  props: [
    'locale'
  ],
  components: {
    LocalInfoFilter,
    LocalInfoList,
    LocalInfoSetting
  },
  computed: {
    list () {
      return this.$store.getters['localinfo/getList']
    }
  },
  created () {
    this.$store.commit('onLoading', true)
    this.$store.dispatch('localinfo/getLocalList').then(() => {
      this.$store.commit('localinfo/initDisplay')
      this.$store.commit('onLoading', false)
    })
  },
  mounted () {
  },
  data () {
    return {
      dirtyFlag: false
    }
  },
  methods: {
    flagOn () {
      this.dirtyFlag = true
    }
  }
}
</script>
